export const DEFAULT_PAGE_KEY_REGEX: Record<string, RegExp> = {
  'add-liquidity': /^\/add-liquidity\/?([?#].*)?$/,
  faucet: /^\/faucet\/?([?#].*)?$/,
  pools: /^\/pools\/?([?#].*)?$/,
  portfolio: /^\/portfolio\/?([?#].*)?$/,
  positions: /^\/positions\/?([?#].*)?$/,
  'remove-liquidity': /^\/remove-liquidity\/?([?#].*)?$/,
  swap: /^\/swap\/?([?#].*)?$/,
  unknown: /^\/unknown\/?([?#].*)?$/,
};
